/**
 * Google API Key and OAuth patterns:
 *
 * 1. Google API Key:
 *    - Usually starts with 'AIza'
 *    - Followed by alphanumeric characters, hyphens, and underscores
 *    - Typically 39 characters total
 *
 * 2. Google OAuth Access Token:
 *    - Usually starts with 'ya29.'
 *    - Followed by alphanumeric characters and special chars
 *    - Variable length
 *
 * 3. Google Cloud Service Account Key:
 *    - JSON format with private_key field
 *    - Contains service account email
 *
 * Examples:
 * - API Key: `AIzaSyDaGmWKa4JsXZ-HjGw7ISLn_3namBGewQe`
 * - OAuth Token: `ya29.a0AfH6SMBx...` (variable length)
 * - Service Account: JSON with "private_key": "-----BEGIN PRIVATE KEY-----\n..."
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-google/src/index.ts
 * - https://cloud.google.com/docs/authentication/api-keys
 * - https://developers.google.com/identity/protocols/oauth2
 */

export const googleApiKey = /\bAIza[A-Za-z0-9_-]{35}\b/;
export const googleOAuthToken = /\bya29\.[A-Za-z0-9_-]{20,}/;
export const googleServiceAccountKey =
  /"private_key":\s*"-----BEGIN PRIVATE KEY-----[^"]+-----END PRIVATE KEY-----"/;
export const googleServiceAccountEmail =
  /\b[a-z0-9_-]+@[a-z0-9_-]+\.iam\.gserviceaccount\.com\b/i;
